export { ConnectedBioEntitiesList } from './ConnectedBioEntitiesList.component';
